module.exports = __webpack_public_path__ + "static/media/image_28.0c205339.png";